import DemoHome from './demo.js';

const Home = DemoHome;

export default Home;
